<template>
    <div>
        <div class="smart-main-search-container flex flex-wrap">
            <div class="w-180 mr-10">
                <el-input v-model="searchParams.dtuNo" placeholder="请输入集中器号"></el-input>
            </div>
            <div class="w-180 mr-10">
                <dropdown placeholder="选择链接状态" v-model="searchParams.runStatus"
                          :data-list="globalData.conRunStatus"></dropdown>
            </div>


            <div class="flex-1"></div>
            <div class="flex">
                <load-button class="mr-10" @on-click="search"></load-button>
                <el-button type="primary" @click="add" plain>新增集中器</el-button>
                <el-button type="primary" @click="exportE" plain>导出数据</el-button>
            </div>
            <div class="flex">
                <upload-button type="primary"  file-char="file" url="/smartMeter/export/concentrator" plain>导入了集中器</upload-button>

            </div>
        </div>

        <div class="content mt-20">
            <smart-table :table-label="labels" :table-data="searchData.list" :table-opt="opt"></smart-table>
        </div>

        <div class="flex flex-right mt-20">
            <pagination :page="searchParams.page" :pages="searchData" @on-search="toPage"></pagination>
        </div>
        <form-dialog ref="model" title="集中器信息" @on-confirm="save">
            <div slot="dialog-main">
                <el-form>

                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="DUT号" label-width="120px">
                                <el-input v-model="temp.dtuNo"></el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-1">
                            <el-form-item label="SIM卡号" label-width="120px">
                                <el-input v-model="temp.simNo"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="安装地址" label-width="120px">
                                <el-input v-model="temp.address"></el-input>
                            </el-form-item>
                        </div>

                    </div>


                </el-form>
            </div>
        </form-dialog>
        <form-dialog ref="model2" title="实时监控" @on-confirm="send">
            <div slot="dialog-main">
                <el-form>

                    <el-form-item label="指令帧" label-width="120px">
                        <el-input v-model="temp2.sendMsg"></el-input>
                    </el-form-item>

                    <el-form-item label="指令帧" label-width="120px">
                        <el-checkbox v-model="temp2.isHex">HEX</el-checkbox>
                    </el-form-item>



                    <el-form-item label="返回帧" label-width="120px">
                        <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 10}"

                                v-model="temp2.backMsg">
                        </el-input>
                    </el-form-item>


                </el-form>
            </div>
        </form-dialog>
    </div>
</template>
<script>
    import LoadButton from "../../components/LoadButton";
    import Pagination from "../../components/Pagination";
    import SmartTable from "../../components/SmartTable";
    import FormDialog from "../../components/FormDialog";
    import UploadImg from "../../components/UploadImg";
    import Dropdown from "../../components/Dropdown";
    import UploadButton from "../../components/UploadButton";

    export default {
        components: {
            Dropdown,
            UploadImg,
            FormDialog,
            SmartTable,
            Pagination,
            LoadButton,
            UploadButton
        },
        data() {
            return {
                searchParams: {
                    page: 1
                },
                searchData: {},
                opt: [
                    {label: '编辑', fn: this.getDetail},
                    {label: '删除', fn: this.delete},
                    {label: '实时监控', fn: this.monitor},
                ],
                labels: [
                    {prop: 'dtuNo', label: '集中器'},
                    {prop: 'simNo', label: 'SIM卡号'},
                    {prop: 'address', label: '安装地址'},
                    {prop: 'runStatus', label: '链接状态', map: this.globalData.conRunStatus},
                    // {prop: 'conpos', label: '安装位置'},
                ],
                temp: {},
                temp2:{}
            }
        },
        mounted() {
            this.getList()
        },
        methods: {
            search(stop) {
                this.searchParams.page = 1
                this.getList(stop)
            },
            toPage(page) {
                this.searchParams.page = page
                this.getList()
            },
            getList(callback) {
                if (this.$store.state.LoginUser.userType == 2) {
                    this.searchParams.gardenId = this.$store.state.LoginUser.gardenId
                }
                this.$http$({
                    method: 'get',
                    url: "/smartMeter/concentrator",
                    data: this.searchParams,
                    load: 1
                }, (data) => {
                    callback ? callback() : ''
                    this.searchData = data
                })
            },
            getDetail(obj) {
                this.temp = JSON.parse(JSON.stringify(obj))
                this.$refs.model.show()
            },
            add() {
                this.temp = {}
                if (this.$store.state.LoginUser.userType == 2) {
                    this.temp.gardenid = this.$store.state.LoginUser.gardenId
                }
                this.$refs.model.show()
            },
            monitor(item){
                this.temp2 = {};
                this.$set( this.temp2,'isHex',false);
                this.$set( this.temp2,'backMsg',"");
                // this.temp2.backMsg = "";
                // this.temp2.isHex = false;
                this.$refs.model2.show();
                // this.$refs.model2.
                this.temp2.id = item.id;
                var model2 = this.$refs.model2;
                var inter = setInterval(()=>{
                   // console.log(model2.isShow() + item.id);
                    this.$http$({method: "get", url: "/smartMeter/concentrator/monitor/"+item.id,data:{isHex:this.temp2.isHex}}, (data) => {
                        // this.getList()
                        // this.$success(msg)
                        // console.log(data)
                        this.$set( this.temp2,'backMsg',this.temp2.backMsg+data);
                        // this.temp2.backMsg = data;
                        console.log(this.temp2.backMsg)

                    })
                    if(!model2.isShow()){
                        clearInterval(inter);
                    }
                },10000)
            },
            send(){
                this.$refs.model2.show();
                this.$http$({method: "post", url: "/smartMeter/concentrator/monitor",data:this.temp2}, (data) => {
                    // this.getList()
                    this.$success("发送成功");

                    // this.temp2.backMsg = this.temp2.backMsg + data;
                })
            },
            save() {
                let method = 'post', url = '/smartMeter/concentrator', msg = '新增集中器成功！'
                if (this.temp.id) {
                    method = "put"
                    // url = '/smartMeterServer/ConcentInfo/update'
                    msg = '修改集中器信息成功！'
                }
                this.$http$({method: method, url: url, data: this.temp}, (data) => {
                    this.getList()
                    this.$success(msg)
                })

            },
            exportE(){
                let url =  this.globalData.host+ "/smartMeter/export/concentrator?accessToken="+this.$store.state.LoginUser.accessToken||"";
                // var isFirst = true;
                for (var i in this.searchParams){
                    url += "&";
                    url+= encodeURIComponent(i) +"=" +encodeURIComponent(this.searchParams[i]);
                }
                this.$http$({method: 'get', url: url}, () => {
                    this.$router.push('/admin/downLoadTask')

                })
            },
            delete(item) {


                this.$fnConfirm('删除集中器将删除所有集中器下的用户，确定删除嘛？',() => {
                    let method = 'delete';
                    let url = '/smartMeter/concentrator/' + item.id;
                    let msg = '删除集中器成功！';
                    this.$http$({method: method, url: url, data: this.temp}, (data) => {
                        this.getList()
                        this.$success(msg)
                    })
                });


            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/pages/admin/Concentrator.vue